import $ from 'jquery';

import widgetFactory from '../widgetFactory';
import confirmService from '../../Services/confirm';

const widgetName = 'switchButton';

const widget = widgetFactory(widgetName, {
  options: {
    confirm: false,
    confirmText: 'confirm ?',
    formElement: null,
  },

  _create: function () {
    this._super(widgetName);

    this.elements.$form = this.options.formElement || this.getWidgetElement('form');
    this.elements.$select = this.elements.$form.find('select');
    this.elements.$firstOptionLink = this.getWidgetElement('firstOption');
    this.elements.$secondOptionLink = this.getWidgetElement('secondOption');

    this.elements.$form.hide();

    this._initSwitchText();
    this._updateSwitchPosition();

    this._addEvents();
  },

  _addEvents: function () {
    this.element.on('click', 'a', this._onClick.bind(this));
  },

  _onClick: function (event) {
    var currentValueIndex = this._getValPositionFromSelect(),
      nextValueIndex = currentValueIndex === 0 ? 1 : 0;

    event.preventDefault();

    if (this.options.confirm) {
      confirmService.show({
        message: this.options.confirmText,
        confirmCallback: function () {
          this.selectValue(nextValueIndex);
        }.bind(this),
      });
    } else {
      this.selectValue(nextValueIndex);
    }
  },

  selectValue: function (nextValueIndex) {
    this.val(this.elements.$select.find('option').eq(nextValueIndex).val());
    this._updateSwitchPosition();
    this.elements.$form.submit();
  },

  _initSwitchText: function () {
    var elements = this.elements,
      $options = $('select option', elements.$form);

    elements.$firstOptionLink.text($options.eq(0).text());
    elements.$secondOptionLink.text($options.eq(1).text());
  },

  _updateSwitchPosition: function () {
    var pos = this._getValPositionFromSelect(),
      classes = ['is-firstSelected', 'is-secondSelected'];

    this.element.removeClass(classes[Math.abs(pos - 1)]).addClass(classes[pos]);
  },

  _getValPositionFromSelect: function () {
    var $select = this.elements.$select,
      $options = $('option', $select),
      find = 0;

    $options.each(
      function (n, option) {
        if (option.value === this.val()) {
          find = n;
        }
      }.bind(this)
    );

    return find;
  },

  val: function (value) {
    return typeof value !== 'undefined'
      ? this.elements.$select.val(value)
      : this.elements.$select.val();
  },
});

export default widget;
